<div [hidden]="!loading" class="mainLoader">
    <mat-spinner class="loading" strokeWidth="6" [diameter]="70"></mat-spinner>
</div>